/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { branchSchema } from "./branchSchema.ts";
import { tableOrderInfoSchema } from "./tableOrderInfoSchema.ts";

export const tableOrderSchema = z.object({
	id: z.uuid(),
	seating_capacity: z.int().min(0).max(2147483647).optional(),
	number: z.int().min(0).max(2147483647),
	branch: branchSchema,
	order: z.uuid().nullable().describe("Устарело, используйте orders: это id первого заказа оттуда."),
	orders: z.array(tableOrderInfoSchema),
	is_free: z.boolean().nullable(),
	external_link: z.string().max(63).nullish(),
	available_extend: z.boolean().nullable().describe("Устарело, используйте orders: это available_extend первого заказа оттуда."),
	tips_link: z.url().max(200).nullish(),
});
